import { useRecoilValue } from 'recoil';
import React from 'react';
import RadioLabel from '../../../../common/radio/RadioLabel';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import { otherBankPrincipalTypeInfoState } from '../../../../../data/estimate/common/otherBank/info/atom';

interface Props {
  text: string;
  type: string;
}

/**
 *  타금융사 할부조건 선수율/할부원금 라디오 로직 컴포넌트
 * @param {string} text 할부원금 or 선수율
 * @param {string} type advanceReceivedRate or installmentPrincipal
 *  */
function OtherBankInstallmentRadio({ text, type }: Props): JSX.Element {
  // selected
  const principalType: string = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPrincipalType' })
  );

  // function
  const update = useUpdateInfo(otherBankPrincipalTypeInfoState);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = e.target.checked;
    checked && update(type);
  };

  return (
    <RadioLabel
      text={text}
      name='otherBank-principalType'
      checked={principalType === type}
      onChange={onChange}
      RadioSize='10px'
      fontSize='11px'
    />
  );
}

export default OtherBankInstallmentRadio;
